import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, from, forkJoin } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

import { Product } from '../interfaces/product.model';
import { GeolocService } from '../providers/geoloc.service';
import { RealtimeApiService } from '../providers/realtime-api.service';
import { StateService } from '../providers/state.service';

@Injectable({ providedIn: 'root' })
export class StoresResolver implements Resolve<Product[]> {
    constructor(private geoSvc: GeolocService, private realtimeSvc: RealtimeApiService, private stateSvc: StateService) { }
    retailer: Array<any>;
    product: Product;
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
        this.product = this.stateSvc.getProduct();
        this.retailer = Object.keys(this.product.product_id);
        return from(this.geoSvc.getCurrentLocation()).pipe(
            mergeMap(location => forkJoin(
                this.retailer.map(retailer => {
                    return this.realtimeSvc.searchStores(retailer, this.product.product_id[retailer], location.zipcode)})
                
                
            ))
        )
    }
}
